module.exports = "images/ppt-big.png";